import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { CLAIM_TYPES } from "../../api/constants";
import ClaimsLog from "../../components/Claims/ClaimsLogs";
import Spinner from "../../components/SpringLoader/index";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { GET, newFetch } from "../../helpers/fetch";
import "./styles.css";

const Claims = ({ sites }) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const activeSiteID = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;
  const [claims, setClaims] = useState([]);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeSite, setActiveSite] = useState(null);
  const [activeSiteAssociate, setActiveSiteAssociate] = useState(null);
  const [totalClaims, setTotalClaims] = useState(0);
  const [totalDeductClaims, setTotalDeductClaims] = useState(0);
  const [totalSafetyShoesClaims, setTotalSafetyShoesClaims] = useState(0);
  const [claimBalance, setClaimBalance] = useState(0);
  const [safetyShoesClaimBalance, setSafetyShoesClaimBalance] = useState(0);
  const [claimTypes, setClaimTypes] = useState([]);
  const [isAssignedClaimApprover, setIsAssignedClaimApprover] = useState(false);
  const today = new Date();
  const monthYear = today.toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
  const year = today.toLocaleString("en-US", {
    year: "numeric",
  });
  const history = useHistory();

  const fetchAll = async () => {
    try {
      let api_path = `/claimtypes/${activeSiteID}`;
      let api_pathClaims = `/associate/claims/${
        JSON.parse(localStorage.getItem("user")).id
      }/null`;
      let claimsResponse = await newFetch(GET, api_pathClaims);
      let response = await newFetch(GET, api_path);
      if (response.success && claimsResponse.success) {
        let claimTypes = response.data;
        let claims = claimsResponse.data;
        setClaimTypes(claimTypes);
        setClaims(claims);
        setTotalClaims(claimsResponse.totalClaim);
        setTotalDeductClaims(claimsResponse.totalDeductClaim);
        setTotalSafetyShoesClaims(claimsResponse.totalSafetyShoesClaim);
        setLoading(false);
      } else {
        if (response.success) {
          ToastUtil.success(claimsResponse.message);
        } else {
          ToastUtil.error(response.message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchClaimApprover = async () => {
    try {
      const asscoiateId = JSON.parse(localStorage.getItem("user")).id;
      let api_path = `/associate/${asscoiateId}/associateapprover/${activeSiteID}`;
      let response = await newFetch(GET, api_path);
      if (response.success) {
        setIsAssignedClaimApprover(response.success);
      } else {
        ToastUtil.error(json.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateState = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    if (activeSite?.enable_ss_claim_limit) {
      if (activeSiteAssociate?.ss_claim_limit) {
        setSafetyShoesClaimBalance(
          parseFloat(
            (
              parseFloat(activeSiteAssociate?.ss_claim_limit || 0) -
              parseFloat(totalSafetyShoesClaims)
            ).toFixed(2)
          )
        );
      }
    }

    if (activeSite?.enable_claim_limit) {
      if (activeSiteAssociate?.claim_limit) {
        if (activeSite?.enable_claim_percentage) {
          setClaimBalance(
            parseFloat(
              (
                parseFloat(activeSiteAssociate?.claim_limit || 0) -
                parseFloat(totalDeductClaims)
              ).toFixed(2)
            )
          );
        } else {
          setClaimBalance(
            parseFloat(
              (
                parseFloat(activeSiteAssociate?.claim_limit || 0) -
                parseFloat(totalClaims)
              ).toFixed(2)
            )
          );
        }
      }
    }
  }, [
    activeSite,
    activeSiteAssociate,
    totalClaims,
    totalDeductClaims,
    totalSafetyShoesClaims,
  ]);

  useEffect(() => {
    fetchClaimApprover();
    fetchAll();
  }, [update]);

  useEffect(() => {
    if (sites.length > 0) {
      const filterSite = sites.find((item) => item.id === activeSiteID);
      setActiveSite(filterSite);
    }
  }, [sites]);

  useEffect(() => {
    const fetchUser = async () => {
      let api_path = "/associate/aboutme";
      let response = await newFetch(GET, api_path);

      if (response.success) {
        if (response.data?.site_associates) {
          const filterSiteAssociate = response.data?.site_associates.find(
            (item) => item.site_id === activeSiteID
          );
          setActiveSiteAssociate(filterSiteAssociate);
        }
      }
    };

    if (user) {
      fetchUser();
    }
  }, []);

  return (
    <div>
      <div className="container pt-4">
        <h4 className="text-brand">
          <Link to="/">
            <i
              className="fas fa-arrow-left link"
              style={{ cursor: "pointer" }}
            />
          </Link>
          &nbsp;&nbsp;{t("Claims")}
        </h4>
        {!loading ? (
          isAssignedClaimApprover ? (
            <>
              {claimTypes.find(
                (item) => item.id === CLAIM_TYPES.STAFF_PURCHASE
              ) &&
                activeSite?.enable_claim_limit && (
                  <div className="claim-style">
                    <span className="font-12">
                      {t("Staff Purchase Claim Balance")} ({monthYear})
                    </span>
                    : {claimBalance.toFixed(2)} SGD
                  </div>
                )}

              {activeSite?.enable_ss_claim_limit &&
                claimTypes.find(
                  (item) => item.id === CLAIM_TYPES.SAFETY_SHOES
                ) && (
                  <>
                    <div className="claim-style">
                      <span className="font-12">
                        {t("Safety Shoes Claim Balance")} ({year})
                      </span>
                      : {safetyShoesClaimBalance.toFixed(2)} SGD
                    </div>

                    <div className="claim-style">
                      <span className="font-12">
                        {t("Total Safety Shoes Claims")} ({year})
                      </span>
                      : {totalSafetyShoesClaims.toFixed(2)} SGD
                    </div>
                  </>
                )}

              {claimTypes.find(
                (item) => item.id === CLAIM_TYPES.STAFF_PURCHASE
              ) &&
                activeSite?.enable_claim_limit && (
                  <div className="claim-style">
                    <span className="font-12">
                      {t("Total Staff Purchase Claims")} ({monthYear})
                    </span>
                    :{" "}
                    {activeSite?.enable_claim_percentage
                      ? totalDeductClaims.toFixed(2)
                      : totalClaims}{" "}
                    SGD
                  </div>
                )}

              <div className="accordion my-3 bg-white" id="accordionFAQs">
                {loading ? (
                  <Spinner />
                ) : (
                  <React.Fragment>
                    <div className="edit-button-wrapper mb-4">
                      <button
                        onClick={() => history.push("/claimsadd")}
                        className="btn btn-design btn-brand"
                      >
                        {t("Submit Claim")}
                      </button>
                    </div>
                    <ClaimsLog
                      claims={claims}
                      updateState={updateState}
                      activeSite={activeSite}
                    />
                  </React.Fragment>
                )}
              </div>
            </>
          ) : (
            <p className="text-muted mt-4 mx-2">
              {t(
                "Sorry, you cannot use the claim because no approver has been assigned. Please contact the admin to assign one for you."
              )}
            </p>
          )
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
};

export default Claims;
